// import validate from "./validate";
const send = (formId, formName, name, email, textArea, button, sendAgain, mailerPath) => {
	const form = document.getElementById(formId);
	const submitButton = document.querySelector(button);
	const inputName = document.querySelector(name);
	const inputEmail = document.querySelector(email);
	const textAreaField = document.querySelector(textArea);
	// let inputsWrapper = document.querySelector(`.${formName}__content--invisible`);
	const inputsWrapper = document.querySelector(`.${formName}__content`);
	const answerWrapper = document.querySelector(`.${formName}__content-after`);
	const backToForm = document.querySelector(`.${sendAgain}__form-again`);

	// const serverResponce = document.querySelector('.responce');
	// const sendAgain = document.querySelector('.form__btn--responce');

	// constsubmitButton= document.querySelector('#send');
	// const openPopupButtons = document.querySelectorAll('.button-contact');
	// const closePopupButton = document.querySelector('.popup__btn-close');
	// const formWrapper = document.querySelector('#form-container');


	// const backToForm = document.querySelector('.popup__form-again');



	submitButton.addEventListener("click", function (event) {

		if (!inputName.value || !inputEmail.value || !textAreaField.value) {
			event.preventDefault();
			const NAME_REGEXP = /[a-zA-Zа-яА-я]/g;
			const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
			function isInputNameValid(value) {
				return (NAME_REGEXP.test(value) && value.length > 4);
			}
			function isInputEmailValid(value) {
				return (EMAIL_REGEXP.test(value) && value.length > 7);
			}
			function isTexAreaValid(value) {
				return (value.length > 1);
			}
			function validateInputs(nameOfInput, validTest) {
				function onInput() {
					if (validTest(nameOfInput.value)) {
						nameOfInput.classList.remove('error');
						// nameOfInput.classList.add('form__input--check');
					} else {
						// nameOfInput.classList.remove('form__input--check');
						nameOfInput.classList.add('error')
					}
				}
				onInput();
			}

			validateInputs(inputName, isInputNameValid);
			validateInputs(inputEmail, isInputEmailValid);
			validateInputs(textAreaField, isTexAreaValid);


		} else {
			const submitFormHandler = async function (event) {
				event.preventDefault();
				let response = await fetch(mailerPath, {
					method: "POST",
					body: new FormData(form),
				});

				if (response.ok) {
					// inputsWrapper.classList.add('popup__content--invisible');
					// answerWrapper.classList.add('popup__content-after--active');

					inputsWrapper.classList.add(`${formName}__content--invisible`);
					answerWrapper.classList.add(`${formName}__content-after--active`);
					inputName.classList.remove('error');
					inputEmail.classList.remove('error');
					textAreaField.classList.remove('error');
				} else {
					// inputsWrapper.classList.add('popup__content--invisible');
					// answerWrapper.classList.add('popup__content-after--active');
					inputsWrapper.classList.add(`${formName}__content--invisible`);
					answerWrapper.classList.add(`${formName}__content-after--active`);
					inputName.classList.remove('error');
					inputEmail.classList.remove('error');
					textAreaField.classList.remove('error');

				}
				form.reset();
				form.removeEventListener('submit', submitFormHandler);
			}
			form.addEventListener('submit', submitFormHandler);
		}
	});

	backToForm.addEventListener("click", (event) => {
		event.preventDefault();
		form.reset();
		inputsWrapper.classList.remove(`${formName}__content--invisible`);
		answerWrapper.classList.remove(`${formName}__content-after--active`);

	});

	// function comebackToForm(event) {
	// 	event.preventDefault();
	// 	inputsWrapper.classList.remove(`${formName}__content--invisible`);
	// 	answerWrapper.classList.remove(`${formName}__content-after--active`);
	// }
	// backToForm.addEventListener('click', comebackToForm);
}
module.exports = send;